

import { mapGetters, mapMutations } from 'vuex';
import FilterSelector from './FilterSelector.vue';

export default {
  name: 'FilterOptions',
  components: {
    FilterSelector,
  },
  props: {
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  computed: {
    ...mapGetters('search/filter', ['selectedAge']),
  },
  methods: {
    ...mapMutations('search/filter', ['SET_SELECTED_AGE']),
    setSelectedAge(value) {
      const index = this.selectedAge.indexOf(value);
      if (index === -1) {
        this.SET_SELECTED_AGE([...this.selectedAge, value]);
      } else {
        this.SET_SELECTED_AGE(this.selectedAge.filter(age => age !== value));
      }
    },
  }
};
